import { Option } from "rc-select";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "../Select";

export const USER_MANAGE_ABILITY_OPTIONS = [
    {
		label: "no-management",
		value: "no-management",
	},
	{
		label: "direct-users",
		value: "direct-users",
	},
	{
		label: "manage-users",
		value: "manage-users",
	},
	{
		label: "direct-users-and-organisation-level",
		value: "direct-users-and-organisation-level",
	},
	{
		label: "direct-org-level-and-users",
		value: "direct-org-level-and-users",
	},
	{
		label: "direct-users-and-location",
		value: "direct-users-and-location",
	},
	{
		label: "direct-users-and-organisation-level-and-location",
		value: "direct-users-and-organisation-level-and-location",
	},
	{
		label: "direct-company",
		value: "direct-company",
	},
	{
		label: "direct-users-and-pay-groups",
		value: "direct-users-and-pay-groups",
	},
	{
		label: "direct-users-and-calculation-group",
		value: "direct-users-and-calculation-group",
	},
	{
		label: "direct-users-and-organisation-level-and-project",
		value: "direct-users-and-organisation-level-and-project",
	},
	{
		label: "direct-project",
		value: "direct-project",
	},
	{
		label: "direct-by-group",
		value: "direct-by-group",
	},
	{
		label: "direct-by-user-group",
		value: "direct-by-user-group",
	},
];

const hierarchyKeys = [
	"direct-users-and-organisation-level",
	"direct-org-level-and-users",
	"direct-users-and-organisation-level-and-location",
	"direct-users-and-organisation-level-and-project",
];

function ManageAbilitySelect({ hierarchyGroup, ...props }) {
	const { t } = useTranslation();

	const options = useMemo(() => {
		return USER_MANAGE_ABILITY_OPTIONS.filter((option) => {
			if (!hierarchyGroup && hierarchyKeys.includes(option.value)) {
				return false;
			}
			if (!hierarchyGroup && option.value === "no-management") {
				return false;
			}
			return true;
		});
	}, [hierarchyGroup]);

	return (
		<Select {...props}>
			{options.map((option) => {
				return (
					<Option key={option.value} value={option.value}>
						{t(option.label)}
					</Option>
				);
			})}
		</Select>
	);
}

export default ManageAbilitySelect;
